"use strict";

var _interopRequireDefault = require("/Users/chuongdev/Desktop/project/333QLK_FE/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/333QLK_FE/node_modules/@babel/runtime/helpers/objectSpread2.js"));
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.object.to-string.js");
var _report = require("@/api/report");
var _moment = _interopRequireDefault(require("moment"));
var _exportReportExcel = require("./export-report-excel");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      tableData: [],
      tableLoading: false,
      title: {
        FREE: "Free Inventory",
        USED: "Used Inventory",
        ALL: "Total Allotted Inventory",
        REMOVED: "Removed Inventory"
      }
    };
  },
  created: function created() {
    this.getData();
  },
  mounted: function mounted() {
    console.log(this.$route);
  },
  methods: {
    tableRowClassName: function tableRowClassName(_ref) {
      var row = _ref.row,
        rowIndex = _ref.rowIndex;
      var diffDay = this.fromNow(row.created_at);
      if (diffDay >= 60) {
        return "red-row";
      } else if (diffDay >= 30) {
        return "yellow-row";
      }
      return "";
    },
    fromNow: function fromNow(dateTime) {
      var current = (0, _moment.default)();
      var time = (0, _moment.default)(dateTime);
      return current.diff(time, "day");
    },
    formatJson: function formatJson(filterVal, jsonData) {
      return jsonData.map(function (v) {
        return filterVal.map(function (j) {
          return v[j];
        });
      });
    },
    downloadReport: function downloadReport() {
      var _this = this;
      var list = this.tableData.map(function (e) {
        return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, e), {}, {
          agingDevices: _this.fromNow(e.created_at)
        });
      });
      (0, _exportReportExcel.exportReportInventoryDetail)(list);
    },
    getData: function getData() {
      var _this2 = this;
      this.tableLoading = true;
      var data = this.$route.query;
      (0, _report.inventoryAgencyDetail)(data).then(function (res) {
        _this2.tableData = res.data;
      }).finally(function () {
        _this2.tableLoading = false;
      });
    }
  }
};